// src/components/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Legal Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-6">
          <Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm">
            Terms of Service
          </Link>
          <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">
            Privacy Policy
          </Link>
          <Link to="/cookies" className="text-gray-300 hover:text-white transition-colors text-sm">
            Cookie Policy
          </Link>
          <Link to="/disclaimer" className="text-gray-300 hover:text-white transition-colors text-sm">
            Disclaimer
          </Link>
          <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm">
            Contact
          </Link>
        </div>
        
        {/* Copyright */}
        <div className="text-center text-gray-400 text-sm">
          <p>© {currentYear} Hello Favors, LLC. All Rights Reserved.</p>
          <p className="mt-2">
            <a href="https://getsecondopinion.co" className="hover:text-white transition-colors">
              getsecondopinion.co
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;